// ColorContext.js
import React, { createContext } from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';

// Create Context
export const ColorContext = createContext();

// Create a provider component
export const ColorProvider = ({ children }) => {
    // website-info is already fetched into Redux by CustomLayout (and cached to
    // localStorage on first load) — read it here instead of fetching it again.
    const websiteInfo = useSelector((state) => state.webDetails?.websiteInfo) || {};
    const loader = _.isEmpty(websiteInfo);
    const colors = {
        header_bg: websiteInfo.header_bg,
        header_text: websiteInfo.header_text,
        footer_bg: websiteInfo.footer_bg,
        footer_text: websiteInfo.footer_text,
    };

    return (
        <ColorContext.Provider value={{colors,loader}}>
            {children}
        </ColorContext.Provider>
    );
};
